import { render, staticRenderFns } from "./BookingAccessPoints.vue?vue&type=template&id=49d004d1&scoped=true&"
import script from "./BookingAccessPoints.vue?vue&type=script&lang=js&"
export * from "./BookingAccessPoints.vue?vue&type=script&lang=js&"
import style0 from "./BookingAccessPoints.vue?vue&type=style&index=0&id=49d004d1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d004d1",
  null
  
)

export default component.exports